<template>
  <el-dialog
    class="update-contract-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="deployTit"
  >
    <el-form
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="合约名称" prop="ContractName">
        <el-input v-model="dataForm.ContractName" disabled></el-input>
      </el-form-item>
      <el-form-item label="当前版本号" prop="ContractVersion">
        <el-input v-model="currentVersion" disabled></el-input>
      </el-form-item>
      <el-form-item label="升级版本号" prop="ContractVersion">
        <el-input v-model="dataForm.ContractVersion"></el-input>
        <div class="tips">合约版本号供识别与维护使用，必须大于当前版本</div>
      </el-form-item>
      <el-form-item label="虚拟机类型" prop="runtimeType">
        <el-select
          v-model="dataForm.runtimeType"
          placeholder="请选择"
          class="auto-width"
          disabled
          @change="handleChange"
        >
          <el-option
            v-for="ele in options"
            :key="parseInt(ele.value)"
            :label="ele.label"
            :value="parseInt(ele.value)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合约文件" prop="file">
        <upload-files ref="contractFile"></upload-files>
      </el-form-item>
      <el-form-item v-show="showAbi" label="ABI文件" prop="evmAbiSaveKey">
        <upload-files ref="abi"></upload-files>
      </el-form-item>
      <el-form-item label="升级理由">
        <el-input
          v-model="dataForm.reason"
          type="textarea"
          placeholder="升级合约需其他组织同意，请输入升级理由（选填）"
          :resize="resize"
          :rows="3"
        ></el-input>
      </el-form-item>
      <el-form-item label="额外信息">
        <operate-param ref="extractParam"></operate-param>
      </el-form-item>
      <el-form-item label="合约调用方法">
        <operate-param ref="methodParam"></operate-param>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="updateContract()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'UpdateContract',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      dialogVisible: false,
      deployTit: '升级合约',
      position: 'right',
      resize: 'none',
      editRule: {
        ContractName: [{ required: true, message: '请输入合约名称', trigger: 'blur' }],
        ContractVersion: [{ required: true, message: '请输入合约版本', trigger: 'blur' }],
        updateVersion: [{ required: true, message: '请输入升级版本', trigger: 'blur' }],
        runtimeType: [{ required: true, message: '请选择虚拟机类型', trigger: 'blur' }],
        file: [{ required: true, message: '请选择合约文件', trigger: 'blur' }],
        evmAbiSaveKey: [{ required: true, message: '请选择ABI文件', trigger: 'blur' }]
      },
      dataForm: {
        ChainId: '',
        ContractName: '',
        ContractVersion: '',
        reason: '',
        parameters: [],
        methods: [],
        compileSaveKey: '', //文件
        runtimeType: 2
      },
      currentVersion: '',
      options: [],
      showAbi: false,
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      //获取虚拟机类型
      this.$apis.chain.getRuntimeTypeList().then(res => {
        if (res.data) {
          let arr = res.data.items
          let newArr = arr.map(ele => {
            let item = {
              label: ele.RuntimeTypeName,
              value: ele.RuntimeTypeType
            }
            return item
          })
          this.options = newArr
        }
      })
    },
    handleCancel() {
      this.dataForm = {
        ChainId: '',
        ContractName: '',
        ContractVersion: '',
        reason: '',
        parameters: [],
        methods: [],
        compileSaveKey: '', //文件
        runtimeType: 2
      }
      this.currentVersion = ''
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.dataForm.ChainId = data.chainId
      this.dataForm.ContractName = data.name
      this.currentVersion = data.version
      this.dataForm.runtimeType = data.runtimeType
      this.showAbi = data.runtimeType === 5 ? true : false
      this.dialogVisible = true
    },
    handleChange(val) {
      if (val === 5) {
        this.showAbi = true
      } else {
        this.showAbi = false
        this.$refs.abi.clear()
      }
    },
    //升级合约
    async updateContract() {
      //获取key,value数据
      this.dataForm.parameters = this.$refs.extractParam.getParam()
      let newMethod = this.$refs.methodParam.getParam()
      this.dataForm.methods = newMethod.map(elem => {
        let item = {
          methodKey: elem.key,
          methodName: elem.value
        }
        return item
      })
      //上传文件
      //判断是否上传abi文件
      if (this.dataForm.runtimeType === 5) {
        this.dataForm.evmAbiSaveKey = await this.uploadFile('abi')
      } else {
        this.dataForm.evmAbiSaveKey = ''
      }
      this.dataForm.compileSaveKey = await this.uploadFile('contractFile')
      this.$apis.chain.upgradeContract(this.dataForm).then(res => {
        if (res) {
          this.$message.success('合约升级成功')
          this.handleCancel()
          this.$emit('update:list')
        }
      })
    },
    uploadFile(refName) {
      return new Promise((resolve, reject) => {
        if (true) {
          let file = this.$refs[refName].getFileRaw()
          let formData = new FormData()
          formData.append('name', file.name)
          formData.append('file', file.raw)
          this.$apis.chain.uploadContract(formData).then(res => {
            if (res.data) {
              resolve(res.data)
            }
          })
        } else {
          reject('')
        }
      }).catch(err => {})
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('update-contract-dialog', (), ());
.update-contract-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
